// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-filter-form-download {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.date-note-alert {
  color: red !important;
  font-weight: 600;
  font-size: 15px;
  font-style: italic;
  text-align: left;
}

  .download-report-field {
    display: flex;
    flex-direction: column;
    width: 25%
  }
      
  .download-report-field label {
    font-weight: bold;
    margin-bottom: 8px;
    text-align: left;
  }
      
  .download-report-field input {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
  }

  .download-report-field select {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
  }
      
  .download-form-actions {
     display: flex;
     gap: 10px;
     align-items: center;
     padding: 15px 0 0;
  }
      
      .download-form-actions .download-btn {
        background: #373435;
        color: #ffcc29;
      }
      
      .download-form-actions .download-btn:hover {
        background: #373435;
        color: #ffcc29;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
      }
        

/* Download Report Table Style */
.download-report-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.download-report-table th,
.download-report-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.download-report-table th {
  background-color: #f4f4f4;
  color: #373435;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
}

.download-report-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.download-report-table tbody tr:hover {
  background-color:  rgba(255, 204, 41, 0.2);
}

.download-report-table td {
  color: #373435;
}

.download-report-table tbody tr:last-child td {
  border-bottom: 2px solid #ffcc29;
}

/* Expand Button */
.download-report-expand-btn {
  background: #373435;
  color: #ffcc29;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
}

.download-report-expand-btn:hover {
  background: #ffcc29;
  color: #373435;
}

/* Expanded Row */
.download-report-expanded-row {
  background-color: #eef7ff;
}

.download-report-expanded-content {
  padding: 10px;
}

.wrap-download-report {
  margin: 0 40px;
}

/* Response Message */
.shortUrlResponse {
  background-color: #28a745;
  color: #fff;
  border-radius: 5px;
  margin: 10px auto;
}

.shortUrlResponse p {
  color: #fff;
  margin-top: 10px;
  padding: 10px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/DownloadReport/DownloadReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;KACG,aAAa;KACb,SAAS;KACT,mBAAmB;KACnB,iBAAiB;EACpB;;MAEI;QACE,mBAAmB;QACnB,cAAc;MAChB;;MAEA;QACE,mBAAmB;QACnB,cAAc;QACd,qFAAqF;MACvF;;;AAGN,gCAAgC;AAChC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".input-filter-form-download {\r\n  display: flex;\r\n  /* flex-wrap: wrap; */\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.date-note-alert {\r\n  color: red !important;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  font-style: italic;\r\n  text-align: left;\r\n}\r\n\r\n  .download-report-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 25%\r\n  }\r\n      \r\n  .download-report-field label {\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n  }\r\n      \r\n  .download-report-field input {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n  }\r\n\r\n  .download-report-field select {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n  }\r\n      \r\n  .download-form-actions {\r\n     display: flex;\r\n     gap: 10px;\r\n     align-items: center;\r\n     padding: 15px 0 0;\r\n  }\r\n      \r\n      .download-form-actions .download-btn {\r\n        background: #373435;\r\n        color: #ffcc29;\r\n      }\r\n      \r\n      .download-form-actions .download-btn:hover {\r\n        background: #373435;\r\n        color: #ffcc29;\r\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n      }\r\n        \r\n\r\n/* Download Report Table Style */\r\n.download-report-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  text-align: left;\r\n}\r\n\r\n.download-report-table th,\r\n.download-report-table td {\r\n  padding: 12px 15px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n}\r\n\r\n.download-report-table th {\r\n  background-color: #f4f4f4;\r\n  color: #373435;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n}\r\n\r\n.download-report-table tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.download-report-table tbody tr:hover {\r\n  background-color:  rgba(255, 204, 41, 0.2);\r\n}\r\n\r\n.download-report-table td {\r\n  color: #373435;\r\n}\r\n\r\n.download-report-table tbody tr:last-child td {\r\n  border-bottom: 2px solid #ffcc29;\r\n}\r\n\r\n/* Expand Button */\r\n.download-report-expand-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n}\r\n\r\n.download-report-expand-btn:hover {\r\n  background: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n/* Expanded Row */\r\n.download-report-expanded-row {\r\n  background-color: #eef7ff;\r\n}\r\n\r\n.download-report-expanded-content {\r\n  padding: 10px;\r\n}\r\n\r\n.wrap-download-report {\r\n  margin: 0 40px;\r\n}\r\n\r\n/* Response Message */\r\n.shortUrlResponse {\r\n  background-color: #28a745;\r\n  color: #fff;\r\n  border-radius: 5px;\r\n  margin: 10px auto;\r\n}\r\n\r\n.shortUrlResponse p {\r\n  color: #fff;\r\n  margin-top: 10px;\r\n  padding: 10px;\r\n  text-align: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
